import React, { useRef, useState } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  Alert
} from '@mui/material';
import './App.css';

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFirebaseLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(emailRef.current.value, passwordRef.current.value);
      navigate('/');
    } catch (err) {
      setError('Failed to login: ' + (err.message || ''));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="section"
      sx={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/MailExMaxBackground.png)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper className="card" elevation={6}>
          <Box p={4}>
            <img
              src="/logo512.png"
              alt="MailExMax Logo"
              className="hero-logo"
            />
            <Typography variant="h4" align="center" gutterBottom>
              MailExMax Sign In
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box
              component="form"
              onSubmit={handleFirebaseLogin}
              sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
            >
              <TextField
                className="text-field"
                label="Email"
                type="email"
                inputRef={emailRef}
                fullWidth
                required
              />
              <TextField
                className="text-field"
                label="Password"
                type="password"
                inputRef={passwordRef}
                fullWidth
                required
              />
              <Button
                className="button"
                type="submit"
                variant="contained"
                size="large"
                disabled={loading}
              >
                {loading ? 'Signing in…' : 'Sign In'}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
